import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@saucelabs/sl-component-grid';
import NotificationsContainer from '@saucelabs/sl-container-notifications';

import SauceLogo from './SauceLogo';
import Styles from './LogoContentWrapper.styles';

const LogoContentWrapper = ({ children }) => (
  <div className={Styles.default}>
    <SauceLogo />
    <NotificationsContainer />
    <div className={Styles['content-wrapper']}>
      <Grid>
        {children}
      </Grid>
    </div>
  </div>
);

LogoContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LogoContentWrapper;
